import { ApiV1Response, http } from 'api/v1/http'

export interface UserPointRank {
  id: number
  userId: number
  address: string
  inviteUserId: number
  inviteUserNum: number
  pointTotal: number
  boost: number
  role: number
  level: number
  tradeNum: number
  tradeAvailable: number
  isWhite: boolean
  isValid: boolean
  createTime: number
  updateTime: number
}
export interface UserReward {
  id: number
  userId: number
  activityCode: string
  rewardId: number
  status: number
  extension: string
  createTime: number
  updateTime: number
}
export interface UserLoyaltyInfo {
  userPointRankVO: UserPointRank
  userPointDayRankVO: any
  rank: number
  dayRank: number
  userRewardVOList: UserReward[]
}
export async function getUserLoyaltyInfo<
  T extends ApiV1Response<UserLoyaltyInfo>
>(activityCode: string): Promise<T> {
  const r = await http.get(`/user-point/user/info?activityCode=${activityCode}`)
  return r.data
}

export interface ChestInfo {
  id: number
  name: string
  extraTradeVol: number
  range: [number, number]
}
export interface LoyaltyConfig {
  name: string
  code: string
  attributes: {
    start: number
    end: number
    rebates: {
      [x: number]: [level: string, boot: string]
    }
    chests: ChestInfo[]
    userCreatedReward: {
      quantity: number
    }
    userInvitedReward: {
      requiredTradeVol: number
      quantity: number
    }
    orderFilledReward: {
      levels: {
        [x: string]: {
          chestId: number
          rate: number
        }[]
      }
    }
  }
  chestMap: {
    [x: string]: ChestInfo
  }
  chests: ChestInfo[]
  userCreatedReward: {
    quantity: number
  }
  userInvitedReward: {
    requiredTradeVol: number
    quantity: number
  }
  valid: boolean
}
export async function getActivityConfig<T extends ApiV1Response<LoyaltyConfig>>(
  activityCode: string
): Promise<T> {
  const r = await http.get(`/user-point/config?activityCode=${activityCode}`)
  return r.data
}

export interface ResponseList<T> {
  records: T
  total: number
  size: number
  current: number
  orders?: []
  optimizeCountSql?: boolean
  searchCount?: boolean
  maxLimit?: number
  countId?: number
  pages: number
}

export interface RankBody {
  id: number
  userId: number
  address: string
  inviteUserId: number
  inviteUserNum: number
  pointTotal: number
  boost: number
  role: number
  level: number
  tradeNum: number
  tradeAvailable: number
  isWhite: boolean
  isValid: boolean
  createTime: number
  updateTime: number
}
export async function getAllRank<
  T extends ApiV1Response<ResponseList<RankBody[]>>
>(current: number, size: number): Promise<T> {
  const r = await http.get(
    `/user-point/rank/page?current=${current}&size=${size}`
  )
  return r.data
}

export async function getDayRank<
  T extends ApiV1Response<ResponseList<RankBody[]>>
>(current: number, size: number): Promise<T> {
  const r = await http.get(
    `/user-point/day/rank/page?current=${current}&size=${size}`
  )
  return r.data
}

export interface RewardHistoryBody {
  id: number
  userId: number
  activityCode: string
  rewardId: number
  status: number
  extension: string
  createTime: number
  updateTime: number
}
export async function getRewardHistory<
  T extends ApiV1Response<ResponseList<RewardHistoryBody[]>>
>(current: number, size: number, activityCode: string): Promise<T> {
  const r = await http.get(
    `/user-reward/page?activityCode=${activityCode}&current=${current}&size=${size}`
  )
  return r.data
}

export async function openChest<
  T extends ApiV1Response<{
    result: boolean
    point: number
  }>
>(params: { rewardId: number; activityCode: string }): Promise<T> {
  const r = await http.post(`/user-reward/open`, {
    ...params,
  })
  return r.data
}

export async function openAllChest<
  T extends ApiV1Response<{
    chests: {
      result: boolean
      point: number
    }[]
  }>
>(params: { activityCode: string }): Promise<T> {
  const r = await http.post(`/user-reward/open/all`, {
    ...params,
  })
  return r.data
}
